<template>
  <SvgIcon :svg="QuestionCircleIcon" :width="width" :class="[$style.icon, props.color === 'gray' ? $style.gray : $style.black]" :style="styleObj" aria-label="説明を表示" />
</template>

<script setup lang="ts">
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import QuestionCircleIcon from '@/svgs/vue/question-circle.svg';

const props = withDefaults(
  defineProps<{
    width?: string;
    color?: 'gray' | 'black';
    top?: string;
  }>(),
  {
    width: '14',
    color: 'gray',
    top: '0',
  },
);
const styleObj = {
  '--top': `${props.top}px`,
};
</script>

<style module lang="scss">
.icon {
  position: relative;
  top: var(--top);

  &.gray {
    fill: var(--color-gray400);
  }

  &.black {
    fill: var(--color-gray800);
  }
}
</style>
